import { render, staticRenderFns } from "./Xlsx.vue?vue&type=template&id=c982932c"
import script from "./Xlsx.vue?vue&type=script&lang=js"
export * from "./Xlsx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports